/* unplugin-vue-components disabled */// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ClickableIcon":"ClickableIcon_1WfJE","active":"active_2L+XB"};